<template>
<div class="w-full sm:w-full md:w-1/3 lg:w-1/3 xl:w-1/3 mb-4">
    <vs-card id="discrepancy-bar-by-client-loading"
    class="vs-con-loading__container px-2 widget-card">
      <card-header :title="$t('widget_discrepancies_by_client')">
        <feather-icon
          icon="FilterIcon"
          svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
          @click="getDiscrepanciesByClient"
        />

        <feather-icon
          icon="RefreshCwIcon"
          svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
          @click="resetDates"
        />
      </card-header>
      <vs-row>
        <vs-col vs-xs="12" vs-sm="6" vs-lg="6" class="pr-1 mt-4">
          <datepicker
            placeholder="Start Date"
            :format="format"
            v-model="startDate"
          ></datepicker>
        </vs-col>
        <vs-col vs-xs="12" vs-sm="6" vs-lg="6" class="pl-1 mt-4">
          <datepicker
            placeholder="End Date"
            :format="format"
            v-model="endDate"
          ></datepicker>
        </vs-col>
      </vs-row>
      <vs-row>
        <vs-col>
          <review-order-stacked-column chartId="barChart" :height="'380'">
          </review-order-stacked-column>
        </vs-col>
      </vs-row>
      <!-- Chart -->
    </vs-card>
  </div>
</template>

<script>
import ReviewOrderStackedColumn from '@/views/modules/import_export/review_order/components/ReviewOrderStackedColumn'
import Datepicker from 'vuejs-datepicker'
import moment from 'moment'
import discrepancy from '@/http/requests/discrepancy'
import loading from '@/mixins/Loading'
import CardHeader from './CardHeader.vue'
export default {
  components: {
    ReviewOrderStackedColumn,
    Datepicker,
    CardHeader
  },
  mixins: [loading],
  computed: {
    isLoading() {
      return this.loading.chart
    },
  },
  watch: {
    isLoading(val) {
      if (val) {
        this.openLoading('discrepancy-bar-by-client-loading')
      } else {
        this.closeLoading('discrepancy-bar-by-client-loading')
      }
    },
  },
  data() {
    return {
      startDate: moment().startOf('month').format('MM-DD-YYYY'),
      endDate: moment().format('MM-DD-YYYY'),
      format: 'MM/dd/yyyy',
      clients: [],
      barChartData: {
        series: [],
        categories: [],
        colors: [],
      },
      params: {
        client: [],
        startDate: null,
        endDate: null,
      },
      loading: {
        chart: false,
      },
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.getDiscrepanciesByClient()
    },
    getDiscrepanciesByClient() {
      this.formatDatesToDB()
      this.loading.chart = true
      discrepancy
        .getDiscrepanciesByClient(this.params)
        .then((res) => {
          let clients = res.data.items
          let colors = clients.map(({ color }) => color)
          let categories = []
          let series = []
          this.clients = clients.map((item) => ({
            name: item.ShortName,
            id: item.ClientId,
          }))
          let index_code = 0
          let index_name = 0
          let names = []
          clients.forEach((item, index) => {
            if (categories.indexOf(item.ShortName) === -1) {
              categories[categories.length] = item.ShortName
            }
            if (names.indexOf(item.ShortName) === -1) {
              names[names.length] = item.ShortName
              index_name = names.length - 1
              series[index_name] = {
                name: item.ShortName,
                data: [],
              }
            }
            index_code = categories.indexOf(item.ShortName)
            index_name = names.indexOf(item.ShortName)
            series[index_name].data[index_code] = Number(item.total)
          })
          /* let series = clients.map((item) =>({
            name:item.ShortName,
            data:[parseInt(item.total)]
          })) */
          this.barChartData = Object.assign({}, this.barChartData, {
            series,
            categories,
            colors,
          })
          ApexCharts.exec(
            'barChart',
            'updateOptions',
            {
              series: this.barChartData.series,
              colors: colors,
              xaxis: {
                categories: categories,
              },
            },
            false,
            true
          )
          this.loading.chart = false
        })
        .catch((err) => {
          this.loading.chart = false
          console.log(err)
        })
    },
    formatDatesToDB() {
      this.params.startDate = moment(this.startDate).format('YYYY-MM-DD')
      this.params.endDate = moment(this.endDate).format('YYYY-MM-DD')
    },
    resetDates() {
      this.startDate = moment().startOf('month').format('MM-DD-YYYY')
      this.endDate = moment().format('MM-DD-YYYY')
      this.getDiscrepanciesByClient()
    },
  },
}
</script>